import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import {
  Visibility as ViewIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  PlayArrow as PlayIcon,
  ReceiptLong as ReceiptLongIcon,
} from "@mui/icons-material";

import { tokens } from "../theme/tokens";
import ActionButton from "./ActionButton";

const TableActionIcon = ({ title, tone = "secondary", children, onClick }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const tones = {
    primary: colors.houndGold[400],
    secondary: colors.scalpelTeal[400],
    danger: colors.softRed[400],
  };

  const color = tones[tone] || tones.secondary;

  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        onClick={onClick}
        sx={{
          width: 34,
          height: 34,
          borderRadius: 2,
          color,
          bgcolor: colors.surface.raised,
          border: `1px solid ${colors.surface.border}`,
          transition:
            "background-color 180ms ease, border-color 180ms ease, transform 180ms ease, box-shadow 180ms ease",
          "&:hover": {
            bgcolor: colors.surface.elevated,
            borderColor: color,
            transform: "translateY(-1px)",
            boxShadow: "0 10px 22px rgba(0,0,0,0.24)",
          },
        }}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
};

const TableActions = ({
  onView,
  onInstantiate,
  onEdit,
  onCosts,
  onDelete,
  onCreateTask,
  hideCreate = false,
}) => (
  <Box display="flex" gap={1} alignItems="center">
    {onView && (
      <TableActionIcon title="View" tone="teal" onClick={onView}>
        <ViewIcon fontSize="small" />
      </TableActionIcon>
    )}

    {onInstantiate && (
      <TableActionIcon title="Use SOP" tone="gold" onClick={onInstantiate}>
        <PlayIcon fontSize="small" />
      </TableActionIcon>
    )}

    {onCosts && (
      <TableActionIcon title="Costs" tone="gold" onClick={onCosts}>
        <ReceiptLongIcon fontSize="small" />
      </TableActionIcon>
    )}

    {onEdit && (
      <TableActionIcon title="Edit" tone="teal" onClick={onEdit}>
        <EditIcon fontSize="small" />
      </TableActionIcon>
    )}

    {onDelete && (
      <TableActionIcon title="Delete" tone="danger" onClick={onDelete}>
        <DeleteIcon fontSize="small" />
      </TableActionIcon>
    )}

    {!hideCreate && onCreateTask && (
      <ActionButton tone="gold" size="small" onClick={onCreateTask}>
        <AddIcon fontSize="small" sx={{ mr: 0.5 }} />
        Task
      </ActionButton>
    )}
  </Box>
);

export default TableActions;